import { render, staticRenderFns } from "./victimDetails.vue?vue&type=template&id=bdf68216"
import script from "./victimDetails.vue?vue&type=script&lang=js"
export * from "./victimDetails.vue?vue&type=script&lang=js"
import style0 from "./victimDetails.vue?vue&type=style&index=0&id=bdf68216&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports